const customScrollbar = () => {
    let customScrollbars = document.querySelectorAll(".custom-scrollbar");
    let scrollBar;
    let modal;
    
    if (customScrollbars.length) {
        customScrollbars.forEach(customScrollbar => {

            scrollBar = OverlayScrollbars(customScrollbar, {
                // scrollbars: {
                //     // autoHide : "never";
                //     visibility: "visible"
                // }
                // paddingAbsolute: true,
                callbacks: {
                    onScroll: function (e) {
                        if (e.target.closest(".popup-content")) {
                            const scrollInfo = scrollBar.scroll();
                            const max = scrollInfo.max.y;
                            const scrollTop = e.target.scrollTop;
                            let isEnd = false;
                            let isTop = false;
        
                            if (max <= scrollTop.toFixed()) {
                                isEnd = true;
                            }
        
                            if (0 < scrollTop.toFixed()) {
                                isTop = true;
                            }
        
                            modal.classList[`${isEnd ? "add" : "remove"}`]("scroll-end");
                            modal.classList[`${isTop ? "add" : "remove"}`]("scroll-top");
                        }
    
                        
                    }
                }
            });

            if(customScrollbar.classList.contains("popup-content")) {
                modal = scrollBar.getElements().target;
            }
            
        });
    }
};

export default customScrollbar;



// WEBPACK FOOTER //
// ./assets/js/modules/customScrollbar.js